<form [formGroup]="loginForm" (submit)="submit()">
    <div class="tagus-form-group without-icon p-20">
        <label
            for="txt-twoFact"
            class="d-block mb-12 fw-semibold gray-color form-label"
            >Two-Factor Auth Code
            <!-- <span>*</span> -->
        </label>
        <mat-form-field appearance="fill">
            <mat-label>Enter your code</mat-label>
            <input
             matInput
                type="text"
                class="form-control"
                id="txt-twoFact"
                placeholder="exp 92982"
                formControlName="twoFactorAuthCode"
                [ngClass]="{
                    'is-invalid':
                        showFieldError(
                            f['twoFactorAuthCode']
                     ) && f['twoFactorAuthCode'].errors
                }"
            />
            <!-- <button
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide"
         >
             <mat-icon>{{
                     hide ? "visibility_off" : "visibility"
             }}</mat-icon>
         </button> -->
        </mat-form-field>
        <button type="submit" mat-flat-button class="tagus fw-semibold btn">Submit</button>
    </div>
   
</form>    
